import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'vc-switch',
	templateUrl: './vc-switch.component.html',
	styleUrls: ['./vc-switch.component.scss'],
})
export class VCSwitch {
	@Input() placement: 'bottom' | 'top-right';
	@Output('displayStateChange') emDisplayStateChange: EventEmitter<string> =
		new EventEmitter<string>();
}
